import { Text } from "components";
import { SVGProps } from "components/icons";
import React from "react";
import { LabelContainerStyle, LabelIconStyle, LabelStyle } from "../styles";

type Props = {
  Icon: React.FC<SVGProps>;
  label: string;
  value: string;
  valueExtra?: string;
};
export const ItemLabel: React.FC<Props> = ({
  label,
  Icon,
  value,
  valueExtra,
}) => {
  return (
    <div className={LabelContainerStyle}>
      <MeetingLabel Icon={Icon} label={label} />
      <Text.BodySM color="primary">{value}</Text.BodySM>
      {valueExtra && <Text.Body2XS color="seconday">{valueExtra}</Text.Body2XS>}
    </div>
  );
};

type MeetingLabelProps = {
  Icon: React.FC<SVGProps>;
  label: string;
};
export const MeetingLabel: React.FC<MeetingLabelProps> = ({ Icon, label }) => {
  return (
    <div className={LabelStyle}>
      <Icon style={LabelIconStyle} fill="highlight/1" />
      <Text.Body2XS color="darkGrey">{label}</Text.Body2XS>
    </div>
  );
};
